// import ArticleIcon from "@mui/icons-material/Article";
import CreateIcon from "@mui/icons-material/Create";
// import EventIcon from "@mui/icons-material/Event";
import ImageIcon from "@mui/icons-material/Image";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import React, { FC, useState } from "react";
// import FlipMove from "react-flip-move";
import InputOption from "./InputOption";
import Modal from "./Modal";
import Post from "./Post";
import PostModal from "./PostModal";
import { Link } from "react-router-dom";


interface Props {
  name: string;
}

const Feed: FC<Props> = ({ name }) => {


  // useEffect(() => {
  //   // firebase-version 9 (latest)
  //   onSnapshot(
  //     query(collection(db, "posts"), orderBy("timestamp", "desc")),
  //     (snapshot) => {
  //       setPosts(snapshot.docs);
  //     }
  //   );
  // }, []);





  const [showModal, setShowModal] = useState(true);
  const openModal = () => {
    setShowModal(!showModal);
  };
  // const user = useSelector(selectUser);
  const [showModal_2, setShowModal_2] = useState("close");

  const handleClick = () => {
    // e.preventDefault();
    // if (e.target !== e.currentTarget) {
    //   return;
    // }

    switch (showModal_2) {
      case "open":
        setShowModal_2("close");
        break;
      case "close":
        setShowModal_2("open");
        break;
      default:
        setShowModal_2("close");
        break;
    }
  };
  return (
    <div className="feed">
      <div className="feed_inputContainer">
        <div>

          <div className="feed_input">
            <button onClick={handleClick} className="search_btn">
              <CreateIcon />
              Start a post
            </button>
          </div>
        </div>

        <div className="feed_inputOptions">
          <InputOption OpenModal={openModal} Icon={ImageIcon} title="Share" color="#70B5F9" />
          <Link to="/JobProfileContainer" state={{ data: "/activejob" }}>
            <InputOption Icon={BusinessCenterIcon} title="Job Post" color="#7FC15E" OpenModal={undefined} />
          </Link>
          <Link to="/applicants" state={{ data: "/newapplicants" }}>
            <InputOption Icon={GroupAddIcon} title="Applicants" color="#E7A33E" OpenModal={undefined} />
          </Link>
          {/* <Link to="/interviews" state={{ data: "/interviews" }}>
            <InputOption Icon={EventIcon} title="Interviews" color="#FC9295" OpenModal={undefined} />
          </Link> */}
          {/* <Link to="/applicants" state={{ data: "/applicantoffered" }}>
            <InputOption Icon={ArticleIcon} title="Offered" color="#0275B1" OpenModal={undefined} />
          </Link> */}
        </div>
      </div>
      {/* Modal here */}

      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        title_option="videooo" e={undefined} />
      <PostModal showModal={showModal_2} handleClick={handleClick} />
      <div className="posts">
        {/* @ts-ignore */}
        {/* <FlipMove> */}
        {/* {posts?.map((post: any, i) => ( */}
        <Post />
        {/* ))} */}
        {/* </FlipMove> */}
      </div>
    </div>
  );
}

export default Feed;
